import { useCountryOptions } from '@e3dc-react/shell/Hooks/useCountryOptions'
import { Box, Stack } from '@mui/material'
import React from 'react'
import { TextField } from 'src/Libs/inputs/formik'
import Select from 'src/Libs/inputs/formik/Select'
import { useAddressForm } from '../../hooks'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(theme => ({
  spacing: {
    marginBottom: theme.spacing(3),
  },
}))

/**
 * Component for customer address used in installation statement.
 * It requires formik context for the input fields.
 */
const CustomerAddress: React.VFC = () => {
  const { allCountries } = useCountryOptions()
  const { customerAddressForm } = useAddressForm()
  const { classes } = useStyles()

  return (
    <Stack spacing={3}>
      <TextField
        sx={{ margin: 19 }}
        required={customerAddressForm.firstName.required}
        name={customerAddressForm.firstName.name}
        label={customerAddressForm.firstName.label}
      />
      <TextField
        required={customerAddressForm.lastName.required}
        name={customerAddressForm.lastName.name}
        label={customerAddressForm.lastName.label}
      />
      <TextField
        required={customerAddressForm.addressAndHouseNumber.required}
        name={customerAddressForm.addressAndHouseNumber.name}
        label={customerAddressForm.addressAndHouseNumber.label}
      />
      <Box sx={{ display: 'flex', flexDirection: 'row' }}>
        <Box sx={{ width: '40%', pr: 2 }}>
          <TextField
            required={customerAddressForm.zipCode.required}
            name={customerAddressForm.zipCode.name}
            label={customerAddressForm.zipCode.label}
          />
        </Box>
        <Box sx={{ flexGrow: 1 }}>
          <TextField required={customerAddressForm.city.required} name={customerAddressForm.city.name} label={customerAddressForm.city.label} />
        </Box>
      </Box>
      <Select
        className={classes.spacing}
        required={customerAddressForm.country.required}
        label={customerAddressForm.country.label}
        name={customerAddressForm.country.name}
        options={allCountries}
        isSearchable
      />
    </Stack>
  )
}

export default CustomerAddress
